var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanceRefund(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 1C3.61438 1 2.67157 1 2.08578 1.56437C1.5 2.12874 1.5 3.03708 1.5 4.85377V8.9904C1.5 10.1434 1.5 10.7198 1.88643 10.9262C2.63474 11.3257 4.0384 9.9926 4.705 9.5912C5.0916 9.3584 5.2849 9.242 5.5 9.242C5.7151 9.242 5.9084 9.3584 6.295 9.5912C6.9616 9.9926 8.36525 11.3257 9.1136 10.9262C9.5 10.7198 9.5 10.1434 9.5 8.9904V5.75",
    stroke: "#3F3F3F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 3.5H5.5",
    stroke: "#3F3F3F",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1L7 4.49977M10.5 4.5L7 1.00023",
    stroke: "#3F3F3F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanceRefund);
export default __webpack_public_path__ + "static/media/cance-refund.18ab4a16ff7f53a18425c60ff2c53b81.svg";
export { ForwardRef as ReactComponent };